import * as React from "react";
import { useEffect, useState } from "react";

import { databaseService, firestoreService } from "utils/firebase";
import { ElementsParallax, SuggestedVideos } from "components";
import Model from "hooks/Model";
import pageStyles from "./styles/LandingStyles";
import BannerHome from "./BannerLanding";
import FeaturesHome from "pages/home/FeaturesHome";
import RolesInfo from "./RolesInfo";
import StatsRow from "./StatsRow";

function HomeScreen() {
  const styles = pageStyles();
  const [suggestedVideos, setSuggestedVideos] = useState([]);

  const firstLoad = async () => {
    try {
      Model.setData("loading", true);

      const suggestedVideosResponse = (
        await databaseService.getDatabase("settings/suggestedVideos")
      ).val();

      if (suggestedVideosResponse.length > 0) {
        const allPromises = suggestedVideosResponse.map((id) =>
          firestoreService.getDoc("videos", id),
        );

        const allVideos = (await Promise.all(allPromises)).map((value) => ({
          ...(value?.data() || {}),
          id: value?.id,
        }));

        setSuggestedVideos(allVideos);
      }
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      Model.setData("loading", false);
    }
  };

  useEffect(() => {
    Model.setData("layoutConfig", { withBg: true });
    firstLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ElementsParallax variant="leftBg" />
      <ElementsParallax variant="rightBg" />
      <div className={styles.container}>
        <BannerHome />
        <StatsRow />
        {/* <BuyTicketsBanner /> */}
        <RolesInfo />
        <SuggestedVideos
          title="🤑 Gana $FROIN mientras apoyas con tus views"
          data={suggestedVideos}
        />
        {/* <RecentBlogPosts /> */}
        <FeaturesHome />
      </div>
    </>
  );
}

export default HomeScreen;
